import { Barcode } from '@frontend/bpost/types';
import { Spinner } from '@frontend/components/common';
import { ICONS } from '@frontend/icons';
import { useModals } from '@frontend/modal';
import { FormattedMessage } from 'react-intl';

import { usePreviewPDF } from './preview-pdf.controller';

export interface PreviewPDFProps {
    barcode: Barcode;
}

export const PreviewPDF = (props: PreviewPDFProps) => {
    const viewProps = usePreviewPDF(props);
    const { closeTopModal } = useModals();

    if (viewProps.error) {
        return (
            <div className='bg-background-surface outline-border-default inline-flex w-full flex-col items-center justify-center gap-6 rounded-md p-6 outline-1 -outline-offset-1'>
                <div className='inline-flex flex-col items-start justify-start gap-2 self-stretch'>
                    <div className='inline-flex h-6 items-center justify-between self-stretch'>
                        <div className='text-foreground-default text-lg font-semibold'>
                            <FormattedMessage
                                id='error.loading.pdf'
                                defaultMessage='Error loading PDF preview'
                            />
                        </div>
                        <ICONS.BUTTON.CLOSE
                            className='hover:cursor-pointer'
                            onClick={() => closeTopModal()}
                        />
                    </div>
                </div>
            </div>
        );
    }

    if (!viewProps.content) {
        return (
            <div className='bg-background-surface outline-border-default inline-flex w-full flex-col items-center justify-center gap-6 rounded-md p-6 outline-1 outline-offset-[-1px]'>
                <div className='text-foreground-default text-lg font-semibold'>
                    <Spinner />
                </div>
            </div>
        );
    }
    return (
        <div className='bg-background-surface outline-border-default flex w-full flex-col items-center justify-center gap-6 rounded-md p-6 outline-1 outline-offset-[-1px]'>
            <div className='flex flex-col items-start justify-start gap-2 self-stretch'>
                <div className='flex h-6 items-center justify-between self-stretch'>
                    <div className='text-foreground-default text-lg font-semibold'>
                        <FormattedMessage
                            id='preview.pdf.title'
                            defaultMessage='Preview PDF'
                        />
                    </div>
                    <ICONS.BUTTON.CLOSE
                        className='hover:cursor-pointer'
                        onClick={() => closeTopModal()}
                    />
                </div>
                <div className='inline-flex h-[50dvh] w-full items-center justify-center'>
                    <iframe
                        title='Preview PDF'
                        height='100%'
                        width='100%'
                        src={viewProps.content}
                    />
                </div>
            </div>
        </div>
    );
};
